import * as React from "react";
import { useTranslation } from "react-i18next";
import { ListGroup, ListGroupItem } from "components/bootstrap";
const EventTypeFilter = ({ onSelect, selectedValues }) => {
  const { t } = useTranslation("widgets");
  const disabledAlertOption = selectedValues.includes("true");
  const disabledEventOption = selectedValues.includes("false");
  return /* @__PURE__ */ React.createElement(ListGroup, { className: "no-bm" }, /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => !disabledAlertOption && onSelect("true"), disabled: disabledAlertOption }, t("events_widget.alert")), /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => !disabledEventOption && onSelect("false"), disabled: disabledEventOption }, t("events_widget.event")));
};
export default EventTypeFilter;
